import React from 'react';

export default function ProgressBar({ percent = 0, accent = 'var(--accent-primary)', height = 6 }) {
  const clamped = Math.max(0, Math.min(100, Number(percent) || 0));
  return (
    <div
      role="progressbar"
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={Math.round(clamped)}
      style={{
        height,
        // Track fills use --bg-tertiary app-wide (see course-card-track /
        // resume-panel-track in courseCard.css / resumePanel.css) — this
        // was on --border-subtle, a step lighter than the rest of the app.
        background: 'var(--bg-tertiary)',
        borderRadius: height,
        overflow: 'hidden',
      }}
    >
      <div
        style={{
          height: '100%',
          width: `${clamped}%`,
          background: accent,
          borderRadius: height,
          transition: 'width 0.4s ease',
        }}
      />
    </div>
  );
}
